var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      on: {
        command: _vm.handleCommand,
        "visible-change": _vm.handleVisibleChange,
      },
      scopedSlots: _vm._u([
        {
          key: "dropdown",
          fn: function () {
            return [
              _c(
                "el-dropdown-menu",
                [
                  _c("el-dropdown-item", { attrs: { command: "small" } }, [
                    _c(
                      "div",
                      { staticClass: "flex_start flex_center_align" },
                      [
                        _c("vab-icon", { attrs: { icon: "font-size" } }),
                        _c(
                          "div",
                          {
                            staticClass: "font",
                            class: { active: _vm.fontChange == "small" },
                          },
                          [_vm._v(" 小 ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-dropdown-item", { attrs: { command: "middle" } }, [
                    _c(
                      "div",
                      { staticClass: "flex_start flex_center_align" },
                      [
                        _c("vab-icon", { attrs: { icon: "font-size" } }),
                        _c(
                          "div",
                          {
                            staticClass: "font",
                            class: { active: _vm.fontChange == "middle" },
                          },
                          [_vm._v(" 中 ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-dropdown-item", { attrs: { command: "big" } }, [
                    _c(
                      "div",
                      { staticClass: "flex_start flex_center_align" },
                      [
                        _c("vab-icon", { attrs: { icon: "font-size" } }),
                        _c(
                          "div",
                          {
                            staticClass: "font",
                            class: { active: _vm.fontChange == "big" },
                          },
                          [_vm._v("大")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("span", { staticClass: "avatar-dropdown" }, [
        _c(
          "div",
          { staticClass: "user-name" },
          [
            _c("vab-icon", { attrs: { icon: "font-size" } }),
            _c("vab-icon", {
              staticClass: "vab-dropdown",
              class: { "vab-dropdown-active": _vm.active },
              attrs: { icon: "arrow-down-s-line" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }